mutation TravelerDelete($input: TravelerDeleteInput!) {
  travelerDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
